import { Modal, ModalContent, ModalBody, Button, ModalFooter } from "@heroui/react";
import { useLocation, useNavigate } from "@remix-run/react";
import { needsToLoginAtom } from "app/atoms/user.atom";
import { lastPage } from "app/atoms/utils.atom";
import { useAtom, useSetAtom } from "jotai";
import { RiLoginBoxLine } from "react-icons/ri";

export default function NeedsToLoginModal() {
  const [_lastPage, setLastPage] = useAtom(lastPage);
  const navigate = useNavigate();
  const location = useLocation();

  const [needsToLogin, setNeedsToLogin] = useAtom(needsToLoginAtom);

  const handleClose = () => {
    setNeedsToLogin(false);
  };
  const handleOpen = (isOpen: boolean) => {
    setNeedsToLogin(isOpen);
  };

  const handleLogin = () => {
    setNeedsToLogin(false);
    //
    setLastPage(location.pathname || "/");
    navigate("/login");
  };

  return (
    <Modal
      size="md"
      isDismissable={false}
      isKeyboardDismissDisabled={false}
      hideCloseButton={false}
      isOpen={needsToLogin}
      onOpenChange={(isOpen) => handleOpen(isOpen)}
      onClose={() => handleClose()}
    >
      <ModalContent className=" dark:bg-gray-800">
        <ModalBody>
          <div className="flex flex-col p-6 space-y-8">
            <div className="rounded-full bg-light w-14 h-14 flex justify-center items-center mx-auto">
              <div className="rounded-full bg-zinc-100 dark:bg-zinc-400 w-14 h-14 flex justify-center items-center aspect-square">
                <RiLoginBoxLine className="text-3xl text-blue-500 dark:text-zinc-800" />
              </div>
            </div>
            <div className="text-center space-y-4">
              {_lastPage}
              <h3 className="text-lg font-medium text-dark dark:text-white">Login Required</h3>

              <p className="dark:text-white">
                In order to keep track of your purchases for extended warranty purposes and future
                discount offerings, please Login or create a free login account.
              </p>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="solid"
            onPress={handleLogin}
            className="font-normal"
            color="primary"
            aria-label="Login Page"
          >
            Continue
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
